import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../../services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';
import { HumanPipe } from './human.pipe';
import { AdminService } from '../../admin/services/admin.service';

@Pipe({
  name: 'message',
  standalone: true,
})
export class MessagePipe implements PipeTransform {
  
  userService = inject(UserService);
  sanitizer = inject(DomSanitizer);
  adminService = inject(AdminService);
  
  users: any[] = [];
  
  constructor() {
    this.userService.getUsers().subscribe((users) => {
      this.users = users.filter((user) => user.role);
    });
  }

  transform(message: any, simple?:boolean, truncate?:number) {
    if (!message || message.deleted === 0) {
      return 'Mensaje eliminado';
    }
    let attachments = "";
    if(simple){
      if (message.pictures && message.pictures.length > 0) {
        attachments += "📷 "
      }
      if (message.document) {
        attachments += "📎 ";
      }
      if (message.calendar_event) {
        attachments += "📅 ";
      }
      if (message.reply) {
        attachments += "💬 ";
      }
    }
    
    if(!message.comment || message.comment.length === 0){
      message.comment = 'Sin mensaje';
      if(message.document){
        const humanPipe = new HumanPipe(this.adminService);
        message.comment = humanPipe.transform(message.document_type);
      }
      else if(message.calendar_event){
        message.comment = message.calendar_event.name;
      }
      else{
        message.comment = 'Sin mensaje';
      }
    }
    
    let value = message.comment;
    value = value.replace(/<\/?[^>]+(>|$)/g, "");

    value = value.replace(/\(user:(\d+)\)/g, (match, userId) => {
      const foundUser = this.users.find(u => u.id === parseInt(userId));
      if(simple){
        return foundUser ? `@${foundUser.name.trim()}` : match;
      }else{
        return foundUser ? `<a class="mention" data-user-id="${userId}">@${foundUser.name.trim()}</a>` : match;
      }
    });
    value = value.replace(/\(client:(\d+)\)/g, (match, clientId) => {
      if(simple){
        return `@Cliente`;
      }else{
        return `<a class="mention" data-client-id="${clientId}">@Cliente</a>`;
      }
    });
    value = value.replace(/【.*】/g, "");
    if (!simple) {
      // Transform Markdown to HTML for non-simple version
      value = marked(value);
    }
    if(truncate && value.length > truncate){
      value = value.substring(0, truncate) + '...';
    }
    if(simple){
      return attachments+value; 
    }else{
      return this.sanitizer.bypassSecurityTrustHtml(attachments+value);
    }
  }
}